function updatePolicyPageTitle(container) {
  const title = container.querySelector('.shopify-policy__title h1');

  if (!(title instanceof HTMLElement)) return;

  const titleMap = {
    '/policies/refund-policy': '返品・返金ポリシー',
    '/policies/privacy-policy': 'プライバシーポリシー',
    '/policies/terms-of-service': '利用規約',
    '/policies/shipping-policy': '配送ポリシー',
    '/policies/contact-information': '連絡先情報',
    '/policies/legal-notice': '特定商取引法に基づく表記',
  };

  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  const matchedTitle = titleMap[pathname];

  if (!matchedTitle) return;

  title.textContent = matchedTitle;
  document.title = `${matchedTitle} | ${document.title.replace(/^.*?\s\|\s/, '')}`;
}

function normalizePolicyHeadingTags(container) {
  const body = container.querySelector('.shopify-policy__body');

  if (!(body instanceof HTMLElement)) return;

  body.querySelectorAll('p').forEach((paragraph) => {
    if (!(paragraph instanceof HTMLElement)) return;

    const strong = paragraph.querySelector(':scope > strong:first-child');

    if (!(strong instanceof HTMLElement)) return;
    if (paragraph.textContent?.trim() !== strong.textContent?.trim()) return;

    const heading = document.createElement('h2');

    while (strong.firstChild) {
      heading.appendChild(strong.firstChild);
    }

    paragraph.replaceWith(heading);
  });
}

function initPolicyPages() {
  document.querySelectorAll('.shopify-policy__container').forEach((container) => {
    if (container instanceof HTMLElement) {
      updatePolicyPageTitle(container);
      normalizePolicyHeadingTags(container);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPolicyPages, { once: true });
} else {
  initPolicyPages();
}
